module.exports = __webpack_public_path__ + "img/back.d1048445.svg";